
import Vue from "vue";
import Notification from "@/components/Common/Notification.vue";
import RULES from "@/mixins/rules";
import CustomFile from "@/components/Common/CustomFile.vue";
import MoneyInput from "@/components/Common/MoneyInput.vue";
import moment from "moment/moment";
import { EspectacularService } from '@/services/EspectacularService';
import { Espectacular } from "@/models/Espectacular";
import { mapGetters } from "vuex";

export default Vue.extend({
  mixins: [RULES],
  components:{
    Notification, CustomFile, MoneyInput
  },
  data: () => ({
    EspectacularService: new EspectacularService('solicitud_espectaculares'),
    dialog: false,
    dialogRechazar: false,
    dialogAprobar: false,
    list: [] as Espectacular[],
    motivo_rechazo: "",
    roles: null,
    dialogPago: false,
    dialogMotivo: false,
    selected_motivo: null as any,
    url: process.env.VUE_APP_API_URL+"constancia_uso_suelo/",
    index: 0,
    solicitudEspectacularId: 0,
    selected_item: null as any,
    pagination: {
      from: 1,
      last_page: 1,
    },
    filters: {
      page: 1,
      folio: '',
      estatus: '',
      contribuyente: '',
      clv_catastral: '',
    },
    disabled: false,
    hasPercentageDescuento: false,
    file: {
      code: 'extraordinario_porcentaje',
      file: '',
      binary: '',
      data: null,
    },
    title: "",
    items: [
      { id: 1, name: 'Pendientes' },
      { id: 3, name: 'Validadas y enviadas a Dirección' },
      { id: 4, name: 'Aprobadas y enviadas a firma' },
      { id: 5, name: 'Rechazadas' },
      { id: 16, name: 'Enviadas al Jefe de Departamento' },
    ],
    dialogSolicitudEspectacularFirmada: false,
    documento:  null as any,
    estatusAviables: [1, 5, 9, 10, 11, 13, 15]
  }),
  computed: {
    ...mapGetters({
      usuario: 'usuario', 
      id: 'id', 
      mini: 'sidebar', 
      contribuyente: "contribuyente",
    }),
  },
  mounted() {
    this.recoveryFilters();
    this.getData();
  },
  watch: {
    "filters.page": function () {
      this.getData();
    },
  },
  methods: {
    formatDate(value: any) {
      return moment(value).add(1, 'days').format("Y/MM/DD")
    },
    recoveryFilters(){
      const savedFilters =  localStorage.getItem('filters-uso-suelo');
      if (savedFilters !== null) {
        if (savedFilters) {
          const parsedFilters = JSON.parse(savedFilters);
          this.filters = parsedFilters;
        }
      }
    },
    saveFilters() {
      localStorage.setItem('filter_espectacular', JSON.stringify(this.filters));
    },
    clearFilters() {
      this.filters = {
        page: 1,
        folio: '',
        estatus: '',
        contribuyente: '',
        clv_catastral: '',
      };
      localStorage.removeItem('filter_espectacular');
      this.getData();
    },
    async showFile(item:any, tipoArchivo: string) {
      const id = item.constancia_uso_suelo[0].constancia;
      //@ts-ignore
      const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

      let file = new Blob([response.data],{type: response.headers['content-type']});
      const url = window.URL.createObjectURL(file);

      //@ts-ignore
      this.documento = {
        //@ts-ignore
        title: tipoArchivo,
        url: url,
        mime: response.headers['content-type']
      }
      this.selected_item = item;
    },
    async getData() {
      this.roles = this.$store.getters.role;

      this.filters.contribuyente = this.contribuyente.id

      if (!this.filters.page) {
        this.filters.page = 1
      }

      let { data:{data,from,last_page}} = await this.EspectacularService.getSolicitudesEspectacularAll(this.filters);
      if (data)
        this.list = data;

      this.pagination = {
        from,
        last_page
      }
    },
    setColor(item: Espectacular, type: any){
      switch (type) {
        case 1:
          switch (item.estatus_revision) {
            case 1:
              if (item.edo_cuenta_status == 6) {
                return "orange";
              }
              break;
            case 3:
              return "blue"; 
            case 4:
              return "green";            
            case 5:
              return "red";
            case 12:
              return "green";
            case 13:
              return "red";
          }
          break;
        case 2:
          if (item.estatus_revision == 6) {
            return "orange";
          }else if (item.estatus_revision == 8) {
            return "green";
          } else if (item.estatus_revision == 9) {
            return "red";
          }
          break;
      }
      return "";
    },
    setStyle(item: Espectacular, type: any){
      switch (type) {
        case 1:
          switch (item.estatus_revision) {
            case 1:
              if (item.edo_cuenta_status == 4) {
                return "orange";
              }
              break;
            case 3:
              return "color: white"; 
            case 4:
              return "color: white";            
            case 5:
              return "color: white";
            case 12:
              return "color: white";            
            case 13:
              return "color: white";
          }
          break;
        case 2:
          console.log(item.estatus_revision)
          if (item.estatus_revision == 6) {
            return "orange";
          }else if (item.estatus_revision == 8) {
            return "green";
          } else if (item.estatus_revision == 9) {
            return "red";
          }
          break;
      }
      return "color: black";
    },
    rechazarSolicitud(idEspectacular: number) {
      this.solicitudEspectacularId  = idEspectacular
      this.dialogRechazar = true;
    },
    actionsMenu(item: any, locacion: any , action: any){
      switch (action) {
        case 'revision':
          break;
        default:
          break;
      }
    },
    async changeStatus(idEspectacular: number, idStatus: number) {
      const object = {
        'estatus_revision': idStatus,
        'motivo_rechazo': idStatus == 5 ? this.motivo_rechazo : ""
      }

      let { data } = await this.EspectacularService.changeStatus(idEspectacular, object);

      if (data.success) {
        this.$toast.success(data.message);
        this.getData();
        this.dialogRechazar = false;
      } else {
        this.$toast.error(data.message);
      }
    },
    async deleteSolicitud(idEspectacular: number) {
      const object = {
        'estatus_revision': 18
      }

      let { data } = await this.EspectacularService.changeStatus(idEspectacular, object);

      if (data.success) {
        this.$toast.success(data.message);
        await this.$router.push({name: 'solicitudEspectaculares'});
        this.getData();
      } else {
        this.$toast.error(data.message);
      }
    },
    async firmarDocumento(idEspectacular: number) {
      const object = {
        'documento_firmado': true,
      }

      let { data } = await this.EspectacularService.firmarDocumento(idEspectacular, object);

      if (data.success) {
        this.$toast.success(data.message);
        this.getData();
      } else {
        this.$toast.error(data.message);
      }
    },
    motivo(solicitudEspectacular: Espectacular){
      this.dialogMotivo = true
      this.selected_motivo = solicitudEspectacular.motivo_rechazo
    },
    async verSolicitudEspectacularFirmada(idEspectacular: number){
      const object = {
        'firmado': true
      }

      await this.EspectacularService.viewDictamenPDF(idEspectacular, object)
      .then((response) => {
          let file = new Blob([response.data],{type: response.headers['content-type']});
          const url = window.URL.createObjectURL(file);
          const tipoArchivo = 'Solicitud Firmada'
          //@ts-ignore
          this.documento = {
              title: tipoArchivo,
              url: url,
              mime: response.headers['content-type']
          }
          this.dialogSolicitudEspectacularFirmada= true;
          this.$toast.success('Dictamen Firmado');
      } )
    }
  }
});
